import React from 'react';
import Navbar from './Navbar';
import { motion } from 'framer-motion';



const leaders = [
  {
    name: "Pavan Kumar U",
    title: "CEO",
    image: "/about/leader/1.png",
    description:
      "Founder & Chief Executive Officer of Ceyone Foundations. He is responsible for providing a strategic vision to Ceyone Foundations in ensuring that the team moves cohesively towards achievement of Mission & Vission of Ceyone Foundations.",
  },
  {
    name: "Avinash Kumar U",
    title: "CFO",
    image: "/about/leader/2.jpg",
    description:
      "As Co-Founder & Chief Financial Officer, leads Ceyone Foundations financial functions and strategies, including accounting, treasury, budgeting and taxation. Additionally, Avinash Kumar A heads Legal, Procurement, Administration and Company Secretarial functions of Ceyone Foundations.",
  },
  {
    name: "Praveen B G",
    title: "CPO",
    image: "/about/leader/3.png",
    description:
      "One of the founders & serves as the Chief Program Officer at Ceyone Foundations and has management responsibility for the organization's funding strategy and portfolio development.",
  },
  {
    name: "Aswit Kumar",
    title: "State Governments & Citizen Engagement",
    image: "/about/leader/4.jpeg",
    description:
      "Head of Strategy and Program Development team at Ceyone Foundations. His role at Ceyone Foundations involves new business opportunities in the skills space.",
  },
  {
    name: "Sandeep Urs",
    title: "Senior Head",
    image: "/about/leader/5.jpg",
    description:
      "Responsible for business development, operations, financing and advocacy to setup demand-driven greenfield skill development institutes and upgrade brownfield ones, through CSR and other financing models.",
  },
  {
    name: "Jayaram",
    title: "Student & Staff Welfare Officer",
    image: "/about/leader/6.jpg",
    description:
      "Responsible for student welfare, health, food security and other welfare activities.",
  },
];

const galleryImages = [
  '/about/gallery/1.jpg',
  '/about/gallery/2.jpg',
  '/about/gallery/3.jpg',
  '/about/gallery/4.JPG',
  '/about/gallery/5.JPG',
  '/about/gallery/6.JPG',
  '/about/gallery/7.jpg',
  '/about/gallery/8.JPG',
  '/about/gallery/9.JPG',
  '/about/gallery/10.JPG',
  '/about/gallery/11.JPG',
  '/about/gallery/12.JPG',

];



const AboutPage = () => {
  return (
    <>
      {/* Hero Section */}
{/* Mobile view: Show two images in one full screen, stacked vertically */}
<div className="sm:hidden bg-white h-screen flex flex-col">
  {/* Top half - Image 2 */}
  <div
    className="relative flex-1 bg-contain bg-no-repeat bg-bottom bg-white flex items-end justify-center"
    style={{ backgroundImage: "url('/about/2.png')" }}
  >
    <div className="absolute inset-0 bg-black opacity-50"></div>
  
  </div>

  {/* Bottom half - Image 1 */}
  <div
    className="relative flex-1 bg-contain bg-no-repeat bg-bottom bg-white flex items-end justify-center"
    style={{ backgroundImage: "url('/about/1.jpg')" }}
  >
    <div className="absolute inset-0 bg-black opacity-50"></div>
    <div className="z-10 text-center text-white px-4 pb-4">
      <h1 className="text-xl font-bold">About The Organization</h1>
    </div>
  </div>
</div>

{/* Desktop view: Show only image 1 full screen */}
<div
  className="hidden sm:flex relative bg-contain bg-no-repeat bg-bottom bg-white h-screen items-end justify-center overflow-hidden"
  style={{ backgroundImage: "url('/about/1.jpg')" }}
>
  <div className="absolute inset-0 bg-black opacity-50"></div>
  <div className="z-10 text-center text-white px-4 pb-10">
    <h1 className="text-5xl font-bold">About The Organization</h1>
  </div>
</div>



      <Navbar />

      {/* About Section */}
   <section className="py-16 bg-white">
  <div className="max-w-screen-xl mx-auto px-4 grid md:grid-cols-2 gap-8 items-center">
    
    {/* Left Image Animation */}
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      className="w-full aspect-[4/3] bg-cover bg-center rounded-md"
      style={{ backgroundImage: "url('/about/3.jpg')" }}
    ></motion.div>

    {/* Right Text Animation */}
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      viewport={{ once: true }}
    >
      <h2 className="text-3xl font-bold mb-4">Our History</h2>
      <p className="mb-4 text-gray-700">
        <strong>Ceyone Foundations®</strong> is a Non-Government Organization established on October 10, 2013 under the Indian Trust Act.
      </p>
      <p className="mb-4 text-gray-700">
        Ceyone Foundations is registered under NITI Aayog with registration number <strong>KA/2018/0198034</strong>, recognized by <strong>NSDC</strong> (National Skill Development Corporation) with Training Provider ID <strong>TP039713</strong>, and recognized by <strong>DDU-GKY</strong> with permanent registration number <strong>KN2019RT30888</strong>.
      </p>
      <p className="mb-4 text-gray-700">
        The organization was set up by professionals from various fields to support Younger India by enhancing personal skills, providing career analysis & assessment, and involving in nation-building efforts to bring positive societal changes for a better India and dignified life for its citizens.
      </p>
      <p className="mb-4 text-gray-700">
        Our core mission is to motivate and build creative skillsets, implement human resource development and management standards, offer career development and guidance, foster entrepreneurship, and provide modular employability, placement & recruitment, vocational training, and support with scholarships & educational loans. We strive to empower youth toward service excellence in both personal and career paths, with the support of private and public sectors.
      </p>
      <p className="text-gray-700">
        Ceyone Foundations aims to promote skill development and socially-needed initiatives by catalyzing the creation of large, quality <strong>PRO (Public Relation Office)</strong> and vocational institutions. Our mandate includes building a supportive system focused on quality assurance and robust information systems — directly or in partnership with Government entities, private organizations, and NGOs.
      </p>
    </motion.div>
  </div>
</section>



<section className="bg-gray-900 text-white py-16">
  <div className="max-w-screen-xl mx-auto px-4">
    <motion.h2
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}                
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="text-3xl font-bold text-center mb-12"
    >
      Legal Existence of Organization
    </motion.h2>

    <div className="grid md:grid-cols-3 gap-8">
      {/* Block 1 */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="text-center bg-gray-800 p-8 rounded-md"
      >
        <span className="block text-lg mb-2">NITI Aayog Registration Number</span>
        <strong className="text-xl font-bold block">KA/2018/0198034</strong>
      </motion.div>

      {/* Block 2 */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        viewport={{ once: true }}
        className="text-center bg-gray-800 p-8 rounded-md"
      >
        <span className="block text-lg mb-2">NSDC Training Partner ID</span>
        <strong className="text-xl font-bold block">TP039713</strong>
      </motion.div>

      {/* Block 3 */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
        viewport={{ once: true }}
        className="text-center bg-gray-800 p-8 rounded-md"
      >
       

       <span className="block text-lg mb-2">NGO Registration Number</span>
        <strong className="text-xl font-bold block">MGC-4-00166-2014-15</strong>
      </motion.div>

    
      {/* <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.6 }}
        viewport={{ once: true }}
        className="text-center bg-gray-800 p-8 rounded-md md:col-span-3"
      >
         <span className="block text-lg mb-2">DDU-GKY Permanent Reg. No.</span>
        <strong className="text-xl font-bold block">KN2019RT30888</strong>
      </motion.div> */}
       
    </div>
  </div>
</section>



<section className="bg-gray-100 py-16">
  <div className="max-w-screen-xl mx-auto px-4">
    <motion.h2
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="text-3xl font-bold text-center mb-8"
    >
      Our Objectives
    </motion.h2>

    <motion.p
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      viewport={{ once: true }}
      className="text-center max-w-3xl mx-auto mb-10 text-gray-700"
    >
      The aim of Ceyone Foundations® through skill developments in the country is to support achieving rapid and inclusive growth.
    </motion.p>

    <div className="grid md:grid-cols-2 gap-12 text-gray-800">
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <ul className="list-disc list-inside space-y-3 text-lg">
          <li>Developing & implementing the skilled youth.</li>
          <li>Empower & stream youth towards nation building.</li>
          <li>Enhancing employability and adaptability to new technologies.</li>
          <li>Improving productivity and living standards.</li>
          <li>Strengthening competitiveness of the country.</li>
          <li>Attracting investment in skill development.</li>
          <li>Adopting strategies to empower people.</li>
          <li>Ensuring employees have effective knowledge and skills.</li>
          <li>Adult learning, retraining, and lifelong learning.</li>
        </ul>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.1 }}
        viewport={{ once: true }}
      >
        <h3 className="text-2xl font-semibold mb-4">Our Priorities</h3>
        <ul className="list-disc list-inside space-y-3 text-lg">
          <li>Reflect standards using available resources.</li>
          <li>Build and share knowledge effectively.</li>
          <li>Promote mentoring and HR practices.</li>
          <li>Foster prosperity, training, and learning.</li>
          <li>Provide leadership on HR issues.</li>
          <li>Create career and development opportunities.</li>
          <li>Address aging workforce and skills gap.</li>
          <li>Engage corporates, schools, and nonprofits.</li>
          <li>Develop and implement HR standards.</li>
        </ul>
      </motion.div>
    </div>
  </div>
</section>


<section className="bg-white py-16">
  <div className="max-w-screen-xl mx-auto px-4">
    <motion.h2
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="text-3xl font-bold text-center mb-12"
    >
      Leadership
    </motion.h2>

    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
      {leaders.map((leader, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: index * 0.1 }}
          viewport={{ once: true }}
          className="bg-gray-100 p-6 rounded-lg shadow-md flex"
        >
          {/* Profile Image */}
          <img
            src={leader.image}
            alt={leader.name}
            className="w-20 h-20 object-cover rounded-md mr-4 flex-shrink-0"
          />

          {/* Text Info */}
          <div>
            <h3 className="text-xl font-semibold mb-1">{leader.name}</h3>
            <p className="text-sm text-gray-600 mb-2">{leader.title}</p>
            <p className="text-gray-800 text-sm">{leader.description}</p>
          </div>
        </motion.div>
      ))}
    </div>
  </div>
</section>


 <section className="bg-gray-100 py-16">
      <div className="max-w-screen-xl mx-auto px-4">
      

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {galleryImages.map((img, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              viewport={{ once: true }}
              className="overflow-hidden rounded-lg shadow-md"
            >
              <img
                src={img}
                alt={`Gallery ${index + 1}`}
                className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>



    <section className="bg-gray-900 text-white py-16">
  <div className="max-w-screen-xl mx-auto px-4">

    {/* Our Mission */}
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="mb-12"
    >
      <h2 className="text-3xl font-bold text-center mb-4">Our Mission</h2>
      <p className="text-center max-w-3xl mx-auto text-gray-300">
        Ceyone Foundations creates the environment for economic growth and opportunities by promoting Human Resource Development Standards, skill up gradation & vocational training, innovation, entrepreneurship, competitiveness, modular employability, placements & recruitments, Career development & guidance by motivating and building the Creative skillsets to empower the youth towards service excellence in their personnel life as well as in their career with the support of private and public sectors.
      </p>
  
    </motion.div>

    {/* Our Vision */}
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      viewport={{ once: true }}
      className="mb-16"
    >
      <h2 className="text-3xl font-bold text-center mb-4">Our Vision</h2>
      <p className="text-center max-w-3xl mx-auto text-gray-300">
        Everyone in our nation, regardless of their income, social position and community, will able to access education and training that will benefit them in gaining social justice, employment and advancing their career aspirations hence being the part of proud SKILLED INDIA.
      </p>
     
    </motion.div>


  </div>
</section>



    </>
  );
};

export default AboutPage;
